import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "../Context/AuthProvider";
import { Login } from "../Pages/Login";
import {Dashboard }from "../Pages/Dashboard";
import { RequiredAuth } from "../Context/RequiredAuth";
import { UsersList } from "../Pages/UsersList";
import { UserById } from "../Pages/UserById";
import { CohortById } from "../Pages/CohortById";
import { Cohorts } from "../Pages/Cohorts";
import { BuildView } from "../Pages/CreateCohort";
import { CreateUser } from "../Pages/CreateUser";
import { NotFound } from "../Pages/NotFound";
import { CohortUpdate } from "../Pages/CohortUpdate";


export const AppRoutes = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<RequiredAuth><Dashboard /></RequiredAuth>} />
          <Route path="/createcohort" element={<RequiredAuth><BuildView /></RequiredAuth>} />
          <Route path="/users" element={<RequiredAuth><UsersList/></RequiredAuth>}/>
          <Route path="/users/:id" element={<RequiredAuth><UserById/></RequiredAuth>} />
          <Route path="/createuser" element={<RequiredAuth><CreateUser/></RequiredAuth>}/>
          <Route path="/cohorts" element={<RequiredAuth><Cohorts /></RequiredAuth>}/>
          <Route path="/cohorts/:id" element={<RequiredAuth><CohortById /></RequiredAuth>}/>
          <Route path="/cohortsUpdate/:id" element={<RequiredAuth><CohortUpdate /></RequiredAuth>}/>
          <Route path="*" element={<NotFound/>} />
        </Routes>
      </Router>
    </AuthProvider>
  )
}